<script lang="ts">
  import ActionButton from '../components/ActionButton.svelte';
  import Premium from '~/icons/Premium.svelte';

  const props: { iconOnly?: boolean } = $props();
</script>

<div class="button-container">
  <ActionButton iconOnly={!!props.iconOnly} href="?premium=t" outlink={false}>
    <Premium />
    Become a Premium Member
  </ActionButton>
</div>

<style lang="scss">
  @use '~/theme/theme';

  .button-container {
    :global(button) {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    & :global(svg) {
      font-size: 24px;
      margin-left: auto;
    }
  }
</style>
